/** Shrinks an image in the browser before upload: longest side ≤ maxSide, re-encoded as JPEG (or WebP when it has transparency). */
const loadImage = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('This image could not be read')); };
  img.src = url;
});

const encode = (canvas, type, quality) => new Promise((resolve) => canvas.toBlob(resolve, type, quality));

export async function shrinkImage(file, { maxSide = 1600, quality = 0.85, alpha = false } = {}) {
  if (!file.type.startsWith('image/') || file.type === 'image/gif') return { file, width: 0, height: 0, original: file.size };
  const img = await loadImage(file);
  const scale = Math.min(1, maxSide / Math.max(img.naturalWidth, img.naturalHeight));
  const width = Math.round(img.naturalWidth * scale);
  const height = Math.round(img.naturalHeight * scale);
  const canvas = document.createElement('canvas');
  canvas.width = width; canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!alpha) { ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, width, height); }
  ctx.drawImage(img, 0, 0, width, height);
  const type = alpha ? 'image/webp' : 'image/jpeg';
  const blob = await encode(canvas, type, quality);
  if (!blob || (blob.size >= file.size && scale === 1)) return { file, width: img.naturalWidth, height: img.naturalHeight, original: file.size };
  const name = `${file.name.replace(/\.[^.]+$/, '') || 'image'}.${alpha ? 'webp' : 'jpg'}`;
  return { file: new File([blob], name, { type }), width, height, original: file.size };
}

export const fmtBytes = (n) => (n >= 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round((n || 0) / 1024))} KB`);
